import { useTranslation } from 'react-i18next';
import { ArrowLeftIcon, ArrowsClockwiseIcon } from '@phosphor-icons/react';

interface GroupDetailHeaderProps {
  groupName?: string;
  memberCount?: number;
  canManage: boolean;
  onBack: () => void;
  onRefresh: () => void;
  onAddMember: () => void;
}

export const GroupDetailHeader = ({
  groupName,
  memberCount,
  canManage,
  onBack,
  onRefresh,
  onAddMember,
}: GroupDetailHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="p-6 border-b border-gray-200">
      <div className="flex items-center gap-4 mb-4">
        <button
          onClick={onBack}
          className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-md transition"
        >
          <ArrowLeftIcon size={20} weight="bold" />
        </button>
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <h1 className="text-3xl font-display text-primary">
              {groupName || t('admin.group_detail.loading')}
            </h1>
            {memberCount !== undefined && (
              <span className="text-gray-500 text-lg">
                {t('admin.group_detail.member_count', { count: memberCount })}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <button
          onClick={onRefresh}
          className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition"
        >
          <ArrowsClockwiseIcon size={20} weight="bold" />
          {t('admin.group_detail.refresh')}
        </button>
        {canManage && (
          <button
            onClick={onAddMember}
            className="flex items-center gap-2 px-4 py-2 bg-primary text-white rounded-md hover:bg-opacity-90 transition"
          >
            <span aria-hidden="true">+</span>
            {t('admin.group_detail.add_member')}
          </button>
        )}
      </div>
    </div>
  );
};
